export var getSectionCategorySubCat = function getSectionCategorySubCat(link) {
  try {
    var categories = link ? link.split("/") : [];
    categories.shift();
    categories.length = categories.length ? categories.length - 1 : categories.length;
    return categories;
  } catch (e) {
    console.log(e, "subCat ERR");
    return [];
  }
};